import * as React from "react";
import { Icon } from "antd";

export interface State {}

export interface Props {
  value: boolean;
}

export default class TickBox extends React.Component<Props, State> {
  render() {
    const { value } = this.props;
    const iconType = value ? "check" : "close";
    const iconColor = value ? "green" : "red";

    return (
      <Icon type={iconType} style={{ color: iconColor }} />
    );
  }
}
